import { inquiryDataConstants } from "../constant/inquiryData.constants";

export const initialState = {
    dataInquiry: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const inquiryDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case inquiryDataConstants.GET_SUCCESS:
            return {
                ...state,
                errorCode: action.inquiryDataList.error_code,
                dataInquiry: action.inquiryDataList.result,
            }; 
        default:
            return state;
    }

};

export default inquiryDataReducer;
